import React from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak from './keycloak';
import "./App.css";
import PrivateRoute from "./PrivateRoute";
import Missions from "./pages/missions";
import Groups from "./pages/groups";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import {CssBaseline} from "@mui/material";
import SendCampaign from "./pages/sendCampaign";
import Stats from "./pages/stats";
import Property from "./pages/property"; // Import du fichier theme.js

function App() {
    // Gestion d'événements Keycloak (facultatif)
    const onEvent = (event, error) => {
        console.log('Keycloak Event:', event);
        if (error) console.error('Keycloak Error:', error);
    };

    // Gestion des Tokens (facultatif : ici pour le debugging)
    const onTokens = tokens => {
        // console.log('Keycloak Tokens:', tokens);
    };

    return (
        <ThemeProvider theme={theme} >
            <div style={{ backgroundColor:  theme.palette.background.default }}>
            <CssBaseline />
            <ReactKeycloakProvider
            authClient={keycloak}
            onEvent={onEvent}
            onTokens={onTokens}
        >
            <Router>
                <Routes>
                    {/* Route publique */}
                    <Route path="/" element={<PrivateRoute><Missions/></PrivateRoute>} />
                    <Route path="/missions" element={<PrivateRoute><Missions/></PrivateRoute>} />
                    <Route path="/groups" element={<PrivateRoute><Groups/></PrivateRoute>} />
                    <Route path="/property" element={<PrivateRoute><Property/></PrivateRoute>} />
                    <Route path="/send" element={<PrivateRoute><SendCampaign/></PrivateRoute>} />
                    <Route path="/stats" element={<PrivateRoute><Stats/></PrivateRoute>} />
                </Routes>
            </Router>
        </ReactKeycloakProvider>
            </div>
        </ThemeProvider>

    );
}

export default App;
